import { fillValues } from '@utils';

// Source: https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const idx = Math.floor(Math.log(bytes) / Math.log(k));
  
  // Showing MB or greater unit. For MB unit, ignore decimal places.
  const i = idx > 1 ? idx : 2;
  const sz = bytes / Math.pow(k, i);
  const fileSize = i == 2 ? Math.round(sz) : parseFloat(sz.toFixed(dm));
  return fileSize + ' ' + sizes[i];
}

const padWithZero = (v: string) => {
  if (Number(v) < 10){
    return "0" + v
  }
  return v
}

export const formatMillisecondsToReadable = (time: number, str: string) => {
  const num = parseInt(String(time), 10)
  const hoursInt = Math.floor(num / 3600)
  const hours =  String(hoursInt)
  const minutes =  padWithZero(String(Math.floor((num - (Number(hours) * 3600)) / 60)))
  
  const parts = str && str.split('{hours}h ')
  const onlyMinutes = str && parts[1]
  const refinedStr = str && hoursInt > 0 ? str : onlyMinutes || "";

  return fillValues(refinedStr, {
    hours,
    minutes
  });
}

export class Milliseconds {
  ms: number
  constructor(milliseconds?: number) {
    this.ms = milliseconds
  }
  
  toHours = () => {
    return this.toMinutes() / 60
  }
  
  toMinutes = () => {
    return this.toSeconds() / 60
  }
  
  toSeconds = () => {
    return this.ms / 1000
  }
  
  fromHours = (nb: number) => {
    return nb * (3600 * 1000)
  }
  
  fromDays = (nb: number) => {
    return this.fromHours(24) * nb
  }
  
}